<template>
	<div
		class="skeleton"
		:class="{
			'skeleton--shimmer': shimmer,
			'skeleton--gradient': gradient,
		}"
		:style="style"
	>
		<slot/>
	</div>
</template>

<script>
export default {
	props: {
		size: String,
		shimmer: Boolean,
		gradient: Boolean,
		circle: Boolean,
		rounded: Boolean,
		'rounded-sm': Boolean,
		'rounded-full': Boolean,
		shadow: Boolean,
		'shadow-light': Boolean,
		absolute: Boolean,
		offsets: String,
		padding: String,
		margin: String,
		noverflow: Boolean
	},
	computed: {
		dimensions: vm => {
			if(!vm.size) return {};
			let [width, height] = vm.size.split(' ');
			return {
				width,
				height: height || width,
			}
		},
		offsetObj: vm => {
			if(!vm.offsets) return;
			let [top, right, bottom, left] = vm.offsets.split(' ');
			return {top, right, bottom, left};
		},
		style: vm => ({
			...vm.dimensions,
			...vm.offsetObj,
			borderRadius: vm.circle ? '100%' : vm.rounded ? '17px' : vm.roundedSm ? '7px' : vm.roundedFull ? '1000px' : '',
			boxShadow: vm.shadow ? '0px 0px 8px #00000080' : vm.shadowLight ? '0px 0px 4px #00000040' : '',
			position: vm.absolute ? 'absolute' : '',
			padding: vm.padding,
			margin: vm.margin,
			overflow: vm.noverflow ? 'hidden' : ''
		})
	}
}
</script>

<style scoped lang="scss">
.skeleton {
	background: #242424;
	position: relative;
	box-sizing: border-box;

	&--gradient {
		background: linear-gradient(to right, #494949, rgb(49, 49, 49));
	}

	&--shimmer {
		overflow: hidden;
		
		&::before {
			height: 100%;
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
			transform: translateX(-100%);
			background-image: linear-gradient(90deg,
				rgba(#4A4949, 0) 0,
				rgba(#4A4949, 0.2) 10%,
				rgba(#4A4949, 0.5) 90%,
				rgba(#4A4949, 0)
			);
			animation: shimmer .7s infinite;
			content: '';
		}
	}

	@keyframes shimmer {
		100% { transform: translateX(100%); }
	}
}
</style>